import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { criarRoteador } from './app/rotas.js';
import { aplicarEscalaGravada } from './ds/escala.js';
import { aplicarTema, lerTema } from './pwa/tema.js';
import './styles/fonte.css';
import './styles/tokens.css';

aplicarTema(lerTema());
aplicarEscalaGravada();

const raiz = document.getElementById('raiz');
if (raiz === null) throw new Error('Elemento #raiz não encontrado.');
createRoot(raiz).render(
  <StrictMode>
    <RouterProvider router={criarRoteador()} />
  </StrictMode>,
);
